import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseFpxRoGridHelper, BaseFpxRoGridHandleAction,ToolBar, GridTransformFn} from '@fpx/core';
import { Emicalculation } from '../emicalculation-service/emicalculation.model';
import { throwError } from 'rxjs';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { EmicalculationService } from '../emicalculation-service/emicalculation.service';

@Injectable()
export class EMICalculationDisplayGridHelper extends BaseFpxRoGridHelper {
  state: any;
  constructor(private _router: Router,
    private processShell:ProcessShellService,
    private _emiService:EmicalculationService) {
    super();
    this.addHandleActions('onClick', this.eMICalculationDisplayGridView);
    this.addHandleActions('modify', this.eMICalculationDisplayGridModify);
    this.addHandleActions('add', this.eMICalculationDisplayGridEntry);
  }
   
  public getGridColumnWidth(): number[] {
    return  [];
  }
  
  override getToolBar():ToolBar[] {
    let toolBar:ToolBar[]=[];
    toolBar.push({ type:'icon', key:'add', name:'add', hoverText:'Add ' });
    toolBar.push({ type:'icon', key:'edit', name:'modify', hoverText:'Modify ' });    
    toolBar.push({ type:'icon', key:'refresh', name:'refresh', hoverText:'Refresh' });
    return toolBar;
  }

  public override getSortSearch(): Map<string, 'sort' | 'search' | 'sort&search' | undefined> {
    let _isSortSearch: Map<string,'sort' | 'search' | 'sort&search' | undefined> = new Map();
    return _isSortSearch;
  }

  private eMICalculationDisplayGridView: BaseFpxRoGridHandleAction = (
    name: string,
    data:Emicalculation
  ) => {
    //WRITE YOUR CODE HERE 
  };
  private eMICalculationDisplayGridModify: BaseFpxRoGridHandleAction = (
    name: string,
    data: Emicalculation
  ) => {
   //WRITE YOUR CODE HERE 
  };
  private eMICalculationDisplayGridEntry: BaseFpxRoGridHandleAction = (
    name: string,
    data:Emicalculation
  ) => {
   //WRITE YOUR CODE HERE 
  };
  
    public override getTransformMap():Map<string,GridTransformFn<any>> {

    let transformMap:Map<string,GridTransformFn<any>> = new Map();
    return transformMap;

  }
  
  public override getGridWidth(): number {
      return 100;
    }
    public override doPreInit(): void {
      this._emiService.FetchDetails().subscribe((res)=>{
        this.state=res;
        console.log(this.state[0].loanDetailList);
        this.processShell.setFooterVisible(false);
      },error=>{
        throwError(error);
      })
    }
}
